// about component
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
    return (
        <Container>
            <Row>
                <Col>
                    <h2>About Ignite</h2>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <img width="100%" src="https://usaignite.com/wp-content/uploads/2023/01/iStock-1168123453.jpg" alt="About Ignite" />
                </Col>
                <Col xs={12} sm={6}>
                    <h3>Proven Leaders + Powerful Ideas: Meet Ignite Business Solutions</h3>
                    <p>
                        With over two decades of experience, Ignite Business Solutions is a team of proven industry leaders with a passion
                        for crafting powerful creative strategies and delivering the highest quality promotional products on the market.
                        As members of the Advertising Specialty Institute and Sage, our experts are avid marketing research enthusiasts who
                        strive to keep our partners trend-savvy, keeping both customers and employees in continuous and effective engagement
                        with your brand.
                    </p>
                </Col>
            </Row>
        </Container>
    );
}
export default About;
